<div class="modal-header">
    <h4>{{ 'INFORMATE_HEADER.BUTTONS_TEXT.EXPORT_REPORTS_OPTIONS.CREATEDATASHEET' | transloco }}</h4>
    <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="closeModal()"><i class="flaticon2-cross"></i></a>
</div>
<div class="modal-body output-lable">
    <div class="row">
        <div class="col-md-4" style="padding: 15px">
            <mat-label class="font-style">{{ 'INFORMATE_HEADER.DATASHEET_REPORT.CUSTOMER' | transloco }}</mat-label>
        </div>
        <div class="col-md-8">
            <mat-form-field class="example-full-width custom-text-field">
                <input
                    type="text"
                    matInput
                    placeholder="{{ 'INFORMATE_HEADER.DATASHEET_REPORT.CUSTOMER' | transloco }}"
                    [(ngModel)]="customer"
                    name="customer"
                />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4" style="padding: 15px">
            <mat-label class="font-style">{{ 'INFORMATE_HEADER.DATASHEET_REPORT.PREPARED_BY' | transloco }}</mat-label>
        </div>
        <div class="col-md-8">
            <mat-form-field class="example-full-width custom-text-field">
                <input
                    type="text"
                    matInput
                    placeholder="{{ 'INFORMATE_HEADER.DATASHEET_REPORT.PREPARED_BY' | transloco }}"
                    [(ngModel)]="preparedBy"
                    name="prepared"
                />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4" style="padding: 15px">
            <mat-label class="font-style">{{ 'INFORMATE_HEADER.DATASHEET_REPORT.DATA_SHEER_REF' | transloco }}</mat-label>
        </div>
        <div class="col-md-8">
            <mat-form-field class="example-full-width custom-text-field">
                <input
                    type="text"
                    matInput
                    placeholder="{{ 'INFORMATE_HEADER.DATASHEET_REPORT.DATA_SHEER_REF' | transloco }}"
                    [(ngModel)]="dataSheetRef"
                    name="data_sheet_ref"
                />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4" style="padding: 15px">
            <mat-label class="font-style">{{ 'INFORMATE_HEADER.DATASHEET_REPORT.COMMENTS' | transloco }}</mat-label>
        </div>
        <div class="col-md-8">
            <mat-form-field class="example-full-width custom-text-field">
                <textarea
                    rows="3"
                    type="text"
                    matInput
                    placeholder="{{ 'INFORMATE_HEADER.DATASHEET_REPORT.COMMENTS' | transloco }}"
                    [(ngModel)]="comments"
                    name="comments_value"
                    style="min-height: 45px; max-height: 45px"
                ></textarea>
            </mat-form-field>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn primary-ebtn" (click)="closeModalWithResult()">
        {{ 'INFORMATE_HEADER.DATASHEET_REPORT.BUTTONS.CONTINUE' | transloco }}
    </button>
    <button type="button" class="btn secondary-ebtn" (click)="closeModal()">{{ 'INFORMATE_HEADER.DATASHEET_REPORT.BUTTONS.CANCLE' | transloco }}</button>
</div>
